import React, { PropsWithChildren } from 'react';

import { VideoEffectOptions } from 'contexts/LiveKitDevicesStateContext/LiveKitDevicesStateContext';
import { ThemeVideoBackgroundOption } from 'contexts/ThemeProvider/types';
import useCustomImages from 'hooks/useCustomImages/useCustomImages';
import { ImageDimensions } from 'modules/MediaDevicesSettings/VisualEffectsSettings/utils/matrixImageStorage';

export const MAX_CUSTOM_BACKGROUNDS = 4;
export const MAX_CUSTOM_BACKGROUNDS_REACHED_ERROR = 'MAX_CUSTOM_BACKGROUNDS_REACHED';
export const GUEST_UPLOAD_NOT_ALLOWED_ERROR = 'GUEST_UPLOAD_NOT_ALLOWED';

export interface CustomImage {
  id: string;
  path: string; // HTTP URL converted from mxc:// URI
  name: string;
  mxcUri: string; // Original mxc:// URI
  hash?: string;
  dimensions?: ImageDimensions;
}

interface CustomImageOption extends ThemeVideoBackgroundOption {
  customImageId: string;
}

export interface CustomImagesContextType {
  customImages: CustomImage[];
  customImageOptions: CustomImageOption[];
  selectedCustomImageId: string | null;
  setSelectedCustomImageId: (id: string | null) => void;
  addCustomImage: (file: File, hash?: string, dimensions?: ImageDimensions) => Promise<string>;
  removeCustomImage: (id: string) => Promise<void>;
  getCustomImageById: (id: string) => CustomImage | undefined;
  getSelectedCustomImagePath: () => string | null;
  getCustomImagePathById: (id: string) => Promise<string | null>;
  getCustomImagePathForEffect: (
    effect: VideoEffectOptions,
    currentPath: string | null | undefined
  ) => Promise<string | null | undefined>;
  isLoading: boolean;
  canUploadMore: boolean;
  remainingSlots: number;
  maxCustomBackgrounds: number;
}

export const CustomImagesContext = React.createContext<CustomImagesContextType | null>(null);

export const CustomImagesProvider = ({ children }: PropsWithChildren) => {
  const customImagesState = useCustomImages();

  return <CustomImagesContext.Provider value={customImagesState}>{children}</CustomImagesContext.Provider>;
};
